<!-- CurrencyText.vue -->
<template>
  <span v-if="displayValue > 0" class="text-success">+{{ currency(displayValue) }}</span>
  <span v-else-if="displayValue < 0" class="text-danger">{{ currency(displayValue) }}</span>
  <span v-else class="text-warning">{{ currency(displayValue) }}</span>
</template>

<script>
export default {
  name: 'CurrencyText',
  props: {
  },
  computed: {
    displayValue () {
      return this.$slots.default[0].text
    }
  },
  methods: {
    currency (amount) {
      amount = (amount * 1.00).toFixed(2)
      //SET NULL OR NaN = 0
      if (!amount || amount === 'NaN') {
        amount = 0
      }
      if (amount >= 0) {
        if (typeof amount === 'number') {
          amount = String(Math.abs(amount))
        }
        return (amount).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      } else {
        amount = String(amount)
        return (amount).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      }
    }
  }
}
</script>
